<mat-form-field
  [class.readonly]="data.attributes?.readOnly"
  [subscriptSizing]="data.subscriptSizing ?? 'fixed'"
  color="accent"
>
  @if (data.label) {
    <mat-label>{{ data.label }}</mat-label>
  }

  <mat-select
    [formControl]="control"
    [required]="data.attributes?.required ?? false"
    [disabled]="data.attributes?.disabled ?? false"
  >
    @if (data.emptyOption) {
      <mat-option value="">{{ data.emptyOption }}</mat-option>
    }

    @for (option of data.options; track option) {
      <mat-option [value]="option.value">
        {{ option.label }}
      </mat-option>
    }
  </mat-select>

  <mat-error [control]="control" [data]="data" uiFormError></mat-error>

  @if (data.hint) {
    <mat-hint [innerHtml]="data.hint"></mat-hint>
  }
</mat-form-field>

@if (data.description) {
  <ui-form-input-description [description]="data.description"></ui-form-input-description>
}
